export default __webpack_public_path__ + "static/media/bulletin.f3ef723f.svg";